import React, { useState, useRef, useContext } from "react";
import "../../../assests/css/studentdashboard/FeeSubmission.css";
import StudentsideLayout from "../../../layouts/StudentsideLayout";
import { AppContext } from "../../../context/Appcontext";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const FeeSubmission = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const challanid = location.state.challanid;
  const loggedInStudent = JSON.parse(localStorage.getItem("student"));
  const { baseUrl } = useContext(AppContext);
  // ── Form states ──────────────────────────────────────
  const [student_id, setStudentId] = useState(loggedInStudent.id);
  const [feechallan_id, setFeechallanId] = useState(challanid);
  const [status] = useState("paid");
  const [image, setImage] = useState(null);

  // ── UI states ────────────────────────────────────────
  const [imagePreview, setImagePreview] = useState(null);
  const [lightboxSrc, setLightboxSrc] = useState(null);

  const fileInputRef = useRef(null);

  // ── Image handler ─────────────────────────────────────
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  // ── Submit (no validation, no dummy data) ─────────────
  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("ngstudent_id", loggedInStudent.id);
    formData.append("ngfeechallan_id", challanid);
    formData.append("status", status);
    formData.append("image", image);

    axios
      .post(`${baseUrl}/student/fee/saveFeeSubmissionProof`, formData, {
        headers: {
          "Content-Type": "multipart-formdata",
        },
      })
      .then((response) => {
        console.log(response.data);
        Swal.fire({
          title: "Congratulations!",
          text: `${response.data.message}`,
          icon: "success",
        }).then(() => {
          navigate(-1);
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <StudentsideLayout>
      <div className="ng-fs-wrapper ng-fs-wrapper--inside-layout">
        {/* ── Card ── */}
        <div className="ng-fs-card">
          {/* Header */}
          <div className="ng-fs-header">
            <div className="ng-fs-header__icon">
              <svg
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <rect x="2" y="5" width="20" height="14" rx="2" />
                <line x1="2" y1="10" x2="22" y2="10" />
              </svg>
            </div>
            <div>
              <h2 className="ng-fs-header__title">Fee Submission</h2>
              <p className="ng-fs-header__subtitle">
                Upload your challan to confirm payment
              </p>
            </div>
          </div>

          {/* Form */}
          <form className="ng-fs-form" onSubmit={handleSubmit}>
            <div className="ng-fs-grid">
              {/* Student ID */}
              <div className="ng-fs-field">
                {/* <label className="ng-fs-label">Student ID</label> */}
                <input
                  className="ng-fs-input"
                  type="text"
                  placeholder="e.g. STU-2024-001"
                  value={student_id}
                  onChange={(e) => setStudentId(e.target.value)}
                />
              </div>

              {/* Fee Challan ID */}
              <div className="ng-fs-field">
                {/* <label className="ng-fs-label">Fee Challan ID</label> */}
                <input
                  className="ng-fs-input"
                  type="text"
                  placeholder="e.g. CHN-2024-045"
                  value={feechallan_id}
                  onChange={(e) => setFeechallanId(e.target.value)}
                />
              </div>

              {/* Status */}
              <div className="ng-fs-field">
                <label className="ng-fs-label">Status</label>
                <div className="ng-fs-status-badge">
                  <span className="ng-fs-status-badge__dot" />
                  {status}
                </div>
              </div>

              {/* Image Upload */}
              <div className="ng-fs-field ng-fs-field--full">
                <label className="ng-fs-label">Challan Image</label>

                <div
                  className="ng-fs-upload-zone"
                  onClick={() => fileInputRef.current?.click()}
                >
                  {imagePreview ? (
                    <img
                      src={imagePreview}
                      alt="preview"
                      className="ng-fs-upload-preview"
                    />
                  ) : (
                    <div className="ng-fs-upload-placeholder">
                      <p>Click to upload challan image</p>
                    </div>
                  )}

                  <input
                    ref={fileInputRef}
                    type="file"
                    accept="image/*"
                    className="ng-fs-upload-input"
                    onChange={handleImageChange}
                  />
                </div>
              </div>
            </div>

            {/* Submit */}
            <div className="ng-fs-actions">
              <button type="submit" className="ng-fs-btn-submit">
                Submit Fee
              </button>
            </div>
          </form>
        </div>

       
        {/* ── Lightbox (still kept) ── */}
        {lightboxSrc && (
          <div className="ng-fs-lightbox" onClick={() => setLightboxSrc(null)}>
            <div
              className="ng-fs-lightbox__inner"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="ng-fs-lightbox__close"
                onClick={() => setLightboxSrc(null)}
              >
                ✕
              </button>
              <img
                src={lightboxSrc}
                alt="full"
                className="ng-fs-lightbox__img"
              />
            </div>
          </div>
        )}
      </div>
    </StudentsideLayout>
  );
};

export default FeeSubmission;